import React, { useState } from "react";
import "./signup.css";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";

const NewSignUp = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState("signup");
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    newsletter: true,
  });
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
    setErrors({ ...errors, [name]: "" });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email) newErrors.email = "Email is required.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      newErrors.email = "Invalid email format.";
    else if (formData.email.endsWith("@gmail.com"))
      newErrors.email = "Please use a work email (no @gmail.com).";
    if (!formData.password) newErrors.password = "Password is required.";
    else if (formData.password.length < 8)
      newErrors.password = "Password must be 8+ characters.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = (e) => {
    e.preventDefault();
    if (validateForm()) setStep("pricing");
  };

  const handleBack = () => {
    if (step === "pricing") setStep("signup");
    else if (step === "integration") setStep("pricing");
    else if (step === "profile") setStep("integration");
  };

  const handleStartTrial = () => setStep("integration");
  const handleSkipPricing = () => setStep("integration");
  const handleIntegrationNext = () => setStep("profile");
  const handleFinish = () =>
    alert("Welcome to Radar+. Your insights dashboard is ready.");

  return (
    <div className="signup-page">
      <div className="container-signup">
        <div className="container-signup">
          {step !== "signup" && (
            <button className="back-button" onClick={handleBack}>
              ← Back
            </button>
          )}

          {step === "signup" && (
            <div className="signup-container-signup">
              <h2>The Ultimate Business Awareness Tool</h2>
              <p>Signup for Free</p>
              <form className="signup-form" onSubmit={handleNext}>
                <div className="form-group">
                  <input
                    type="email"
                    name="email"
                    placeholder="Work Email (e.g., name@company.com)"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                  {errors.email && (
                    <span className="error">{errors.email}</span>
                  )}
                </div>
                <div className="form-group password-group">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Password (8+ characters)"
                    value={formData.password}
                    onChange={handleInputChange}
                    required
                  />
                  <span className="eye-icon" onClick={togglePasswordVisibility}>
                    {showPassword ? "👁️" : "👁️‍🗨️"}
                  </span>
                  {errors.password && (
                    <span className="error">{errors.password}</span>
                  )}
                </div>
                <label>
                  <input
                    type="checkbox"
                    name="newsletter"
                    checked={formData.newsletter}
                    onChange={handleInputChange}
                  />
                  Sign Up for Weekly Insight Newsletter
                </label>
                <button type="submit">Next</button>
              </form>
              <p className="switch-link">
                Already have an account?{" "}
                <span onClick={() => navigate("/login")}>
                  Sign in
                </span>
              </p>
              <p className="join-text">Join 150+ Others</p>
              <div className="testimonials-section">
                <div className="testimonials-ticker">
                  <div className="ticker-content">
                    <p>“Avoided $50K+ and closed 27% more deals”</p>
                    <p>
                      “32% boost in retention after launching twice as fast”
                    </p>
                    <p>“Saved $75K and boosted margins 22%”</p>
                    <p>“Saved $500K on rent and 18% more profitable”</p>
                    {/* Duplicate for smooth looping */}
                    <p>“Avoided $50K+ and closed 27% more deals”</p>
                    <p>
                      “32% boost in retention after launching twice as fast”
                    </p>
                    <p>“Saved $75K and boosted margins 22%”</p>
                    <p>“Saved $500K on rent and 18% more profitable”</p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {step === "pricing" && (
            <div className="pricing-overlay">
              <h2>Pick Your Plan—Free 14-Day Trial</h2>
              <div className="pricing-options">
                <div
                  className={classNames("plan", {
                    ["highlighted"]: formData.selectedPlan === "Starter",
                  })}
                  onClick={() =>
                    setFormData({ ...formData, selectedPlan: "Starter" })
                  }
                >
                  <h3>Starter</h3>
                  <p>$49/month · Small SMBs (10-50 employees)</p>
                  {formData.selectedPlan === "Starter" && <span>Selected</span>}
                </div>
                <div
                  className={classNames("plan", {
                    ["highlighted"]: formData.selectedPlan === "Professional",
                  })}
                  onClick={() =>
                    setFormData({ ...formData, selectedPlan: "Professional" })
                  }
                >
                  <h3>Professional</h3>
                  <p>$99/month · Mid-tier SMBs (50-200 employees)</p>
                  {formData.selectedPlan === "Professional" && (
                    <span>Most Popular</span>
                  )}
                </div>
                <div
                  className={classNames("plan", {
                    ["highlighted"]: formData.selectedPlan === "Enterprise",
                  })}
                  onClick={() =>
                    setFormData({ ...formData, selectedPlan: "Enterprise" })
                  }
                >
                  <h3>Enterprise</h3>
                  <p>$199/month · Larger SMBs (200-500 employees)</p>
                  {formData.selectedPlan === "Enterprise" && (
                    <span>Selected</span>
                  )}
                </div>
              </div>
              <div className="pricing-buttons">
                <button className="skip" onClick={handleStartTrial}>
                  Start 14 Day Trial
                </button>
                {/* <button className="skip-now" onClick={handleSkipPricing}>
                  Skip for Now
                </button> */}
              </div>
            </div>
          )}

          {step === "integration" && (
            <div className="integration-page">
              <h2>Let’s Get Started</h2>
              <p>Connect Financial or PM Software.</p>
              <div className="integration-box">
                <button onClick={() => alert("Sign in to QuickBooks")}>
                  Sign in to QuickBooks
                </button>
                <button onClick={() => alert("Sign in to Salesforce")}>
                  Sign in to Salesforce
                </button>
                <p>Connected!</p>
                <button className="skip" onClick={() => setStep("profile")}>
                  Set Up Later
                </button>
              </div>
              <button className="skip" onClick={handleIntegrationNext}>
                Next
              </button>
            </div>
          )}

          {step === "profile" && (
            <div className="profile-page">
              <h2>Let’s Get to Know You Better</h2>
              <p>For sharper insights, tell us about your business.</p>
              <form className="profile-form" onSubmit={handleFinish}>
                <div className="form-group">
                  <input type="text" placeholder="Company Name" required />
                </div>
                <div className="form-group">
                  <select required>
                    <option value="" className="form-options">Main Industry</option>
                    <option value="tech">Technology</option>
                    <option value="retail">Retail</option>
                    <option value="finance">Finance</option>
                  </select>
                </div>
                <div className="form-group">
                  <select required>
                    <option value="">Sector</option>
                    <option value="saas">SaaS</option>
                    <option value="e-commerce">E-commerce</option>
                    <option value="services">Services</option>
                  </select>
                </div>
                <button type="submit">Finish</button>
              </form>
            </div>
          )}
        </div>
        <footer>
          <div className="footer-links">
            <a href="/pricing">Pricing</a> | <a href="/features">Features</a> |{" "}
            <a href="/contact">Contact</a>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default NewSignUp;
